import util from '@bmp-vue/core/api/util'

const controller = 'CredorConta'
export default Object.assign({}, util.GetCrud(controller, null), {
    CredorSolicitacao: function (id) {
        return util.Axios.Get(controller + '/CredorSolicitacao', id);
    },
    CredorSolicitacaoPorConta: function (id) {
        return util.Axios.Get(controller + '/CredorSolicitacaoPorConta', id);
    }
})
